module.exports = __webpack_public_path__ + "static/blog06-4a19e16a1b06e7792940ead91316ef13.png";